import { useCallback, useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { Outlet } from "react-router";
import { BROADCAST_MESSAGE } from "~/broadcastChannel/broadcastChannelManager";
import { useBroadcastChannel } from "~/hooks/useBroadcastChannel";
import { getAuthenticationContextReference } from "~/helpers/getAuthenticationContextReference";

const FORCED_PIN_CHANGE_REDIRECTED_KEY = "forcedPinChangeRedirected";

export const ProtectedRoute = () => {
  const { signinRedirect, user } = useAuth();
  const mustChangePin = Boolean(user?.profile?.must_change_pin);

  const redirectToIdp = useCallback(async () => {
    const acrValues = getAuthenticationContextReference(
      user?.profile?.idp,
      user?.profile?.locale
    );

    await signinRedirect({...(acrValues && { acr_values: acrValues })});
  }, [signinRedirect, user]);

  /* Subscribe to broadcast channel messages */
  useBroadcastChannel(BROADCAST_MESSAGE.LOGOUT, redirectToIdp);

  // The IdP forces the PIN change only at authorize, which refresh-token renewal skips.
  // Redirect once per tab so an IdP that does not force it cannot cause a loop.
  useEffect(() => {
    if (!mustChangePin) {
      sessionStorage.removeItem(FORCED_PIN_CHANGE_REDIRECTED_KEY);
      return;
    }

    if (sessionStorage.getItem(FORCED_PIN_CHANGE_REDIRECTED_KEY)) {
      return;
    }

    sessionStorage.setItem(FORCED_PIN_CHANGE_REDIRECTED_KEY, "true");
    redirectToIdp();
  }, [mustChangePin, redirectToIdp]);

  return <Outlet />;
};
